import React from 'react';
import {ButtonBar, SaveButton, DeleteButton, Form, Field, MultiSelect} from '../commons/Forms.js';
import ReactSpinner from 'react-spinjs';
import {connect} from 'react-redux';
import {modifyUser, deleteUser, addUser} from '../../redux/users/actions';
import {Pane, Part} from '../commons/Panes';
import {NEW_ELEMENT_ID} from '../../redux/_commons/const';

/** Panneau d'ajout/edition/suppression d'utilisateur */
@connect(
  state => ({connectedUser: state.user}),
  {modifyUser, deleteUser, addUser}
)
export default class extends React.Component {

  /** Ajoute ou édite un utilisateur en fonction */
  onSubmit(e) {
    e.preventDefault();
    let {user} = this.props;

    let data = Object.assign({}, user, {
      id: user.id !== NEW_ELEMENT_ID ? user.id : undefined,
      name: this.refs.name.value(),
      api_token: user.id !== NEW_ELEMENT_ID ? undefined : this.refs.api_token.value(),
      skiresort_ids: this.refs.skiresort_ids.value()
    });

    // POST and PUT requests on users needs user data
    // to be in an user attribute
    if (user.id === NEW_ELEMENT_ID) {
      this.props.addUser({user: data});
    } else {
      this.props.modifyUser({user: data, id: user.id});
    }

    return false;
  }

  onDeleteClicked() {
    const user = this.props.user;
    if (confirm('Êtes-vous sûr de vouloir supprimer l\'utilisateur ' + user.name + ' ? ')) {
      this.props.deleteUser(user.id);
    }
  }

  render() {
    const {user, inProgress} = this.props;

    if (inProgress) {
      return (
        <Pane style={{right: 300}} title="&nbsp;">
          <Part title="Utilisateur">
            <ReactSpinner/>
          </Part>
        </Pane>
      );
    }

    let skiresortChoices = this.props.connectedUser.infos.ski_resorts.reduce(
      (prev, cur) => {
        prev[cur.name] = cur;
        return prev;
      },
      {}
    );

    let selectedIds = Object.values(user.skiresorts || {}).map(s => s.id);

    return (
      <Pane title="&nbsp;" className="groomer-edition-form">
        <button type="button"
                className="cancel-button"
                onClick={() => this.props.onCancel()}>
          <i className="mi mi-cancel"/>
        </button>
        <Part title="Utilisateur">
          <Form onSubmit={e => this.onSubmit(e)}>
            <Field ofType="text" label="Nom" required={true} ref="name"
                   value={user.name}/>


            <Field ofType="text" label="Code d'accès" required={true} ref="api_token"
                   disabled={user.id !== NEW_ELEMENT_ID ? 'disabled' : null}
                   value={user.api_token}/>
            <MultiSelect label="Stations" ref="skiresort_ids"
                         selectedIds={selectedIds} choices={skiresortChoices} valueKey="name"/>

            <ButtonBar>
              <SaveButton/>
              { user.id !== NEW_ELEMENT_ID ? <DeleteButton onClick={() => this.onDeleteClicked()}/> : null }
            </ButtonBar>
          </Form>
        </Part>
      </Pane>
    );
  }

}




// WEBPACK FOOTER //
// ./src/components/admin/UserEditionForm.js